import { Grid, Typography } from '@material-ui/core';
import { Button, FileUpload, FileUploadArea, TextField } from '@roc/ui';
import { DocumentStore } from '@roc/feature-documents';
import { useGeneralTasksStore } from '@roc/feature-general-tasks';
import { ManualTaskInfo } from './manualTaskInfo';
import { LoanProcess } from '@roc/feature-utils';
import { observer } from 'mobx-react';
import { useState, useEffect } from 'react';
type ManualProps = {
  store: DocumentStore,
  handleClose: () => void,
  resetOnUnmount?: boolean
}
export const ManualTaskForm = observer(
  ({ store, handleClose, resetOnUnmount = true }: ManualProps) => {
    const [uploads, setUploads] = useState<FileUpload[]>([]);
    const { generalTasksStore } = useGeneralTasksStore();
    const { editTaskStore } = generalTasksStore;
    const onSave = async () => {
      if (generalTasksStore.statusUpdateReason) {
        generalTasksStore.updateTaskStatusReason(store.currentDocument?.taskId, generalTasksStore.statusUpdateReason);
      }
      if (uploads[0]) {
        await store.uploadDocument(uploads[0].file, store.currentDocument, LoanProcess.UNDERWRITING);
      }
      handleClose();
    };
    useEffect(() => {
      generalTasksStore.setLoanTaskComments(editTaskStore?.taskV2?.statusUpdateReason || '');
      return () => {
        if (resetOnUnmount) {
          editTaskStore.reset();
          generalTasksStore.setLoanTaskComments('');
        }
      }
    }, [])

    useEffect(() => {
      generalTasksStore.setLoanTaskComments(editTaskStore?.taskV2?.statusUpdateReason || '');
    }, [editTaskStore?.taskV2?.statusUpdateReason])

    return (
      <Grid container spacing={2}>
        <ManualTaskInfo document={store?.currentDocument} store={store} description={editTaskStore?.taskV2?.description ?? ''} />
        <Grid item xs={12}>
          <TextField
            type="text-area"
            variant="outlined"
            label="Item Explanation"
            value={generalTasksStore.statusUpdateReason}
            onChange={e => generalTasksStore.setLoanTaskComments(e.target.value)}
            fullWidth
            multiline={true}
            minRows={4}
            margin="normal"
            testId="shareUrl"
          />
        </Grid>
        <Grid item xs={12}>
          <FileUploadArea
            items={uploads}
            setItems={(items) => setUploads(items)}
            multiple={false} />
        </Grid>
        <Grid container spacing={2} justifyContent="center">
          <Grid item>
            <Button
              type="button"
              variant="contained"
              color="default"
              testId="cancel"
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Grid>
          <Grid item>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              testId="save"
              onClick={onSave}
            >
              Save
            </Button>
          </Grid>
        </Grid>

      </Grid>
    );
  }
);
